/**
 * @ngdoc service
 * @name Fullstory
 * @description
 * This service works as interface with FullStory to identify users
 * sessions on this system.
 *
 * @memberof account
 */
class Fullstory {
  /**
   * Class constructor.
   * @param {Service} $window                 To get the global FullStory object.
   * @param {Service} waitForExternalLibrary  Required to know when the FullStory service has been
   *                                          successfully started.
   * @ignore
   */
  constructor($window, waitForExternalLibrary) {
    'ngInject';

    /**
     * The local reference to the `$window` service.
     * @type {Object}
     */
    this.$window = $window;
    /**
     * Local reference to `waitForExternalLibrary` service.
     * @type {Object}
     */
    this.waitForExternalLibrary = waitForExternalLibrary;
  }
  /**
   * Returns a `$q` promise that will be resolved when `window.FS` becomes available, in
   * order to prevent the usage of FS if the thing has not been loaded yet (async script,
   * network problems, whatever).
   * @return {Promise}
   */
  load() {
    return this.waitForExternalLibrary.toLoad('FS');
  }
  /**
   * Identity an User on Fullstory
   * @param {String} userEmail  Current user's email.
   * @param {Object} value      Object with customer and user information.
   * @return {Promise}
   */
  identify(userEmail, value) {
    return this.load().then(() => {
      this.$window.FS.identify(userEmail, value);
    });
  }
  /**
   * Clear Fullstory cookie
   * @return {Promise}
   */
  clearUserCookie() {
    return this.load().then(() => {
      this.$window.FS.clearUserCookie();
    });
  }
}

export default Fullstory;



// WEBPACK FOOTER //
// ./src/frontend/modules/account/services/fullStory.js